import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslations from '../locales/en/translation.json'
import faTranslations from '../locales/fa/translation.json'
import type { PostProcessorModule } from 'i18next'
import { toPersianDigits } from '@/lib/localize-digits'

const persianDigitsPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'persianDigits',
  process(value: string, _key, _options, translator) {
    if (translator?.language === 'fa') {
      return toPersianDigits(value)
    }
    return value
  },
}

i18n
  .use(persianDigitsPostProcessor)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      fa: {
        translation: faTranslations,
      },
    },
    lng: (() => {
      if (typeof window !== 'undefined') {
        const stored = localStorage.getItem('language')
        if (stored && (stored === 'en' || stored === 'fa')) {
          return stored
        }
        // Detect browser language
        const browserLang = navigator.language.split('-')[0]
        if (browserLang === 'fa') return 'fa'
      }
      return 'en'
    })(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    postProcess: ['persianDigits'],
  })

export default i18n
